<template>
    <div>
        <div class="grid-fitted grid-unstackable">
            <div class="grid-item">
                <p>PayPal</p>
            </div>
            <div class="grid-item no-flex">
                <img class="border-radius-s" src="/static/icons/payment-instruments/paypal/paypal-card-dark.svg" style="width: 32px;"/>
            </div>
        </div>
    </div>
</template>

<script>
    import {vIcon} from '@/components/form';

    export default {
        name: 'paypal-view',
        components: {vIcon},
        props: {
            instrument: Object,
            isCompact: {
                type: Boolean,
                default: true,
            },
        },
    };
</script>
